import React, { Component } from "react";
import { connect } from "react-redux";

import FormPortal from "../portals/FormPortal";
import ReisplannerPortal from "../portals/ReisplannerPortal";
import ReisadviezenFlexPortal from "../portals/ReisadviezenFlexPortal";
import ReisadviezenPortal from "../portals/ReisadviezenPortal";
import ReisadviesPortal from "../portals/ReisadviesPortal";
import ReisadviezenTravelservicesPortal from "../portals/ReisadviezenTravelservicesPortal";
import DienstregelingFormPortal from "../portals/DienstregelingFormPortal";
import DienstregelingPortal from "../portals/DienstregelingPortal";
import StoringenFormPortal from "../portals/StoringenFormPortal";
import StoringenPortal from "../portals/StoringenPortal";
import HalteFormPortal from "../portals/HalteFormPortal";
import HalteHeaderPortal from "../portals/HalteHeaderPortal";
import HalteLinesPortal from "../portals/HalteLinesPortal";
import HalteDeparturesPortal from "../portals/HalteDeparturesPortal";
import ReisadviesPricesPortal from "../portals/ReisadviesPricesPortal";
import ShopOverviewPortal from "../portals/ShopOverviewPortal";
import DiscountCalculatorPortal from "../portals/DiscountCalculatorPortal";
import Toaster from "../components/Common/Toaster";
import SearchPortal from "../portals/SearchPortal";
import CheckoutFormPortal from "../portals/CheckoutFormPortal";
import CookiesPortal from "../portals/CookiesPortal";
import PopularProductsPortal from "../portals/PopularProductsPortal";
class App extends Component {
  render() {
    return (
      <React.Fragment>
        <CheckoutFormPortal />
        <CookiesPortal />
        <FormPortal />
        <ReisplannerPortal />
        <ReisadviezenFlexPortal />
        <ReisadviezenPortal />
        <ReisadviesPortal />
        <ReisadviezenTravelservicesPortal />
        <ReisadviesPricesPortal />
        <DienstregelingFormPortal />
        <DienstregelingPortal />
        <DiscountCalculatorPortal />
        <StoringenFormPortal />
        <StoringenPortal />
        <HalteFormPortal />
        <HalteHeaderPortal />
        <HalteLinesPortal />
        <HalteDeparturesPortal />
        <ShopOverviewPortal />
        <SearchPortal />
        <Toaster />
        <PopularProductsPortal />
      </React.Fragment>
    );
  }
}

export default connect()(App);



// WEBPACK FOOTER //
// ./src/containers/App.js